<template>
    <div class="project-container">
        <div class="top-title">
            <h2>宁夏固原市西吉县旺吉农业2024年冷凉蔬菜数字农业示范基地项目</h2>
        </div>

        <!-- 证书与描述区 -->
        <el-row :gutter="16" class="main-content">
            <!-- 左侧：数字农业智能驾驶舱 -->
            <el-col :span="8">
                <img :src="dashboardImg" alt="数字农业智能驾驶舱" class="main-img">
            </el-col>

            <!-- 右侧：平台描述 -->
            <el-col :span="14">
                <div class="desc-card">
                    <p>
                        我公司于2024年开始实施宁夏固原市西吉县旺吉农业2024年冷凉蔬菜数字农业示范基地项目，立足高海拔冷凉气候特色，深度融合数字技术与设施农业，打造集“智能感知、精准调控、全链管理”于一体的高原冷凉蔬菜产业样板。
                    </p>
                    <p>
                        项目通过全域部署环境智能监测站、智能卷帘机自动控制系统、智能水肥一体机，智能微压打药系统等，实现温室光照、温湿度、二氧化碳等核心参数动态追踪与自适应调控，精准匹配冷凉蔬菜生长周期需求。同步构建“育苗-栽培-采收”全流程数字化管理体系，以数据驱动农事操作标准化、设备运维自动化，显著提升生产效能与品质一致性。
                    </p>
                    <p>
                        项目依托我公司自主研发的云端协同管控系统，突破高寒地区设施农业技术瓶颈，获评自治区数字农业创新应用标杆案例，带动西吉县冷凉蔬菜产业集约化、品牌化升级，为西北高海拔区域探索“数字+特色农业”融合发展提供创新路径。
                    </p>
                </div>
            </el-col>
        </el-row>

        <!-- 底部图片展示区 -->
        <div class="image-grid">
            <el-row :gutter="15">
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/xjtwo.png" alt="" class="project-img">
                    <p class="img-p">
                        棚主正在使用我公司生产的
                        小型物联网控制柜
                    </p>
                </el-col>
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/xjthree.png" alt="" class="project-img">
                    <p class="img-p">
                        配备我公司生产的
                        智能水肥一体机（专业版）
                    </p>
                </el-col>
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/xjfour.png" alt="" class="project-img">
                    <p class="img-p">
                        配备我公司生产的
                        智能微压打药系统
                    </p>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NingxiaProjectPage',
    data() {
        return {
            dashboardImg: require('@/assets/images/MainTypicalcase/xjone.png')

        }
    }
}
</script>